import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { AcceptTransferMiners } from "../../api/api";

type PermissionsResult = {
  status: string;
  notification?: boolean;
  msg?: string;
};

type AcceptTransferInput = {
  jobid: string;
};

export const useAcceptMinerTransfer = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation({
    mutationFn: ({
      jobid,
      token,
    }: AcceptTransferInput & {
      token: string;
    }): Promise<PermissionsResult> =>
      AcceptTransferMiners(token, {
        jobid,
      }),

    onSuccess: (data) => {},

    onError: (error) => {
      console.error(
        "Error performing miner operations:",
        error
      );
    },
  });

  const mutateWithToken = useCallback(
    async (
      { jobid }: AcceptTransferInput,
      options?: {
        onSuccess?: (data: PermissionsResult) => void;
        onError?: (error: any) => void;
        onSettled?: () => void;
      }
    ) => {
      console.log("sites in attach permissions", jobid);
      const token = await getAccessTokenSilently();
      console.log();
      mutation.mutateAsync(
        {
          jobid,
          token,
        },
        {
          onSuccess: options?.onSuccess,
          onError: options?.onError,
          onSettled: options?.onSettled,
        }
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate: mutateWithToken };
};
